import {apiUrl, dateFormat, alert, isEmptyObj} from '../helper'
import $ from 'jquery'
// import VipDialogView from '../components/Search/VipDialog.vue'
import moment from 'moment'

export default {
  data () {
    return {
      startdate: '',
      enddate: '',
      suggestNum: -1,
      queue: [],
      suggestagain: true,
      suggestions: [],
      oldsuggestValue: '',
      suggTyp: {1: 'a', 2: 'n3b', 6: 'h'},
      showInd: false,
      showPla: false,
      havelabels: false,
      showMylabels: 1,   // 切换我的标签和已选条件
      showType: true,    // 公告类型
      showQaType: true,   // 问题类型
      showPlate: true,    // 板块类型
      showRegion: true,   // 地区类型
      showSecurityCompany: true,  // 主办券商
      showIndustry: true,   // 行业类型
      pageshowConditions: {
        'type': {},
        'qaType': {},
        'plate': {},
        'region': {},
        'securityCompany': {},
        'industry': {
          'A农，林，牧，渔业': [],
          'B采矿业': [],
          'C制造业': [],
          'D电力、热力、燃气及水生产和供应业': [],
          'E建筑业': [],
          'F批发和零售业': [], 'G交通运输、仓储和邮政业': [], 'H住宿和餐饮业': [], 'I信息传输、软件和信息技术服务业': [], 'J金融业': [], 'K房地产业': [], 'L租赁和商务服务业': [], 'M科学研究和技术服务业': [], 'N水利、环境和公共设施管理业': [], 'O居民服务、修理和其他服务业': [], 'P教育': [], 'Q卫生和社会工作': [], 'R文化、体育和娱乐业': []},
        'plate': {'SZZB': '', 'SZZXB': '', 'SZCYB': '', 'SHZB': '', '挂牌公司': [], 'N3BTS': ''},
        'labels': {}
      },
      conditions: {   // 条件
        'type': {},
        'qaType': {},
        'plate': {},
        'layer': {},
        'region': {},
        'industry': {},
        'industrysecond': {},   // 行业子类
        'securityCompany': {},
        'labels': {}
      },
      anoConditions: {
        'type': {},
        'qaType': {},
        'plate': {},
        'layer': {},
        'region': {},
        'industry': {},
        'industrysecond': {},
        'securityCompany': {},
        'labels': {}
      },
      showChildFlag: {
        'plate': false,
        'industry': false
      },
    }
  },
  watch: {
    'ttype': function (val, oldVal) {
      this.ttype_name = this.ttypeMap[val]
    },
    'datetype': function (val, oldVal) {
      if (val === 1) {
        this.datetype_name = '一个月'
      }
      if (val === 2) {
        this.datetype_name = '一个季度'
      }
      if (val === 3) {
        this.datetype_name = '半年'
      }
      if (val === 4) {
        this.datetype_name = '去年'
      }
      if (val === 5) {
        this.datetype_name = '今年'
      }
      if (val === 6) {
        this.datetype_name = '一年'
      }
      if (val === 7) {
        this.datetype_name = '两年'
      }
      if (val === 8) {
        this.datetype_name = '三年'
      }
      if (val === 9) {
        this.datetype_name = '五年'
      }
      if (val === 10) {
        this.datetype_name = '十年'
      }
      if (val === 98) {
        this.datetype_name = '全部'
      }
      if (val === 99) {
        this.datetype_name = '自定义'
      }
    }
  },
  methods: {
    // 切换日期范围
    changeDateType (val) {
      // console.log('commonMix.js changeDateStype')
      let now = new Date()
      this.datetype = val
      if (val === 1) {
        this.startdate = dateFormat(new Date(now.getTime() - 30 * 86400 * 1000), 'yyyy-MM-dd')
        this.enddate = dateFormat(now, 'yyyy-MM-dd')
      }
      if (val === 2) {
        this.startdate = dateFormat(new Date(now.getTime() - 90 * 86400 * 1000), 'yyyy-MM-dd')
        this.enddate = dateFormat(now, 'yyyy-MM-dd')
      }
      if (val === 3) {
        this.startdate = dateFormat(new Date(now.getTime() - 180 * 86400 * 1000), 'yyyy-MM-dd')
        this.enddate = dateFormat(now, 'yyyy-MM-dd')
      }
      if (val === 4) {
        this.startdate = moment().add(-1, 'Y').format('YYYY-01-01')
        this.enddate = moment().add(-1, 'Y').format('YYYY-12-31')
      }
      if (val === 5) {
        this.startdate = moment().format('YYYY-01-01')
        this.enddate = dateFormat(now, 'yyyy-MM-dd')
      }
      if (val === 6) {
        this.startdate = dateFormat(new Date(now.getTime() - 365 * 86400 * 1000), 'yyyy-MM-dd')
        this.enddate = dateFormat(now, 'yyyy-MM-dd')
      }
      if (val === 7) {
        this.startdate = dateFormat(new Date(now.getTime() - 2 * 365 * 86400 * 1000), 'yyyy-MM-dd')
        this.enddate = dateFormat(now, 'yyyy-MM-dd')
      }
      if (val === 8) {
        this.startdate = dateFormat(new Date(now.getTime() - 3 * 365 * 86400 * 1000), 'yyyy-MM-dd')
        this.enddate = dateFormat(now, 'yyyy-MM-dd')
      }
      if (val === 9) {  // 五年
        this.startdate = dateFormat(new Date(now.getTime() - 5 * 365 * 86400 * 1000), 'yyyy-MM-dd')
        this.enddate = dateFormat(now, 'yyyy-MM-dd')
      }
      if (val === 10) {
        this.startdate = dateFormat(new Date(now.getTime() - 10 * 365 * 86400 * 1000), 'yyyy-MM-dd')
        this.enddate = dateFormat(now, 'yyyy-MM-dd')
      }
      if (val === 98) {
        this.startdate = ''
        this.enddate = ''
      }
    },
    arrowkey: function (e) {
      console.log(e)
      // e.preventDefault()
      if (this.suggestions.length > 0 && (e.keyCode === 38 || e.keyCode === 40)) {
        e.preventDefault()
        if (e.keyCode === 38) {
          // e.preventDefault()
          let lis = $('.company-menu li')
          console.log($('.company-menu li'))
          var num = 0
          for (let i of lis) {
            if (!$(i).is(":focus")) {
              num = num + 1
            } else {
              // $(i)[num - 1].blur()
              if (num === 0) {

                $('.company-menu li')[this.suggestions.length - 1].focus()
              } else {

                $('.company-menu li')[num - 1].focus()
              }
              break
            }
          }
          if (num === lis.length) {

            $('.company-menu li')[this.suggestions.length - 1].focus()
          }
        }
        if (e.keyCode === 40) {
          // e.preventDefault()
          let lis = $('.company-menu li')
          var num = 0
          for (let i of lis) {
            if (!$(i).is(":focus")) {
              num = num + 1
            } else {
              // $(i)[num - 1].blur()
              if (num === (this.suggestions.length - 1)) {

                $('.company-menu li')[0].focus()
              } else {

                $('.company-menu li')[num + 1].focus()
              }
              break
            }
          }
          if (num === lis.length) {

            $('.company-menu li')[0].focus()
            // alert(';123')
          }
        }
      }
    },
    suggest: function (d, e) {
      if (d.length < 2) {
        this.oldsuggestValue = d
        this.queue = []
        this.suggestions = []
        this.suggestNum = -1
        return false
      }
      if (this.stype === 3) {
        return false
      }
      if (d && d !== this.oldsuggestValue) {
        this.oldsuggestValue = d

        // if (!this.suggestagain) {
        //   return false
        // }

        this.suggestagain = false
        let value = d.split(' ')
        if (window.location.href.indexOf('mysecurities') < 0) {
          var query = {name: [], count: 10, stype: this.suggTyp[this.stype]}
        } else {
          var query = {name: [], count: 10}
        }

        for (let i of value) {
          if (i) {
            query.name.push(i)
          }
        }
        this.suggestions = []
        this.suggestNum = this.suggestNum + 1
        this.ajaxSuggest(query, this.suggestNum)
        console.log(this.queue)
        }
    },
    ajaxSuggest: function (query, n) {
      $.ajax({
        url: apiUrl('/V1.0.0/notice/suggestcompany'),
        method: 'post',
        dataType: 'json',
        // async:false,
        data: JSON.stringify(query)
      }).done((response) => {
        this.suggestagain = true
        // this.oldsuggestValue = this.companyCode
        if (response.status === 0 && response.data.result[0].length > 0) {
          // if (this.companyCode.length < 2) {
          //   this.oldsuggestValue = this.companyCode
          //   this.queue = []
          //   this.suggestions = []
          //   this.suggestNum = -1
          //   return false
          // }
          // for (let item of response.data.result[0]) {
          //   let i = item[2] + ' ' + item[0]
          //   this.suggestions.push(i)
          // }
          // this.suggestions = response.data.result[0]
          // console.log(this.suggestions)
          this.queue[n] = response.data.result[0]
          this.suggestions = this.queue[this.queue.length - 1]
          // return this.suggestions
        } else {
          this.queue[n] = []
          this.suggestions = this.queue[this.queue.length - 1]
        }
      }).fail((response) => {
        this.suggestagain = true
        // this.oldsuggestValue = this.companyCode
        console.log('请求失败')
        this.queue[n] = []
        this.suggestions = this.queue[this.queue.length - 1]
      })
    },
    // 根据conditions变化来更新pageshowConditions内容，用于展示，与实际搜索条件又区别
    addToShow: function () {
      // let keyarr = ['type', 'qaType', 'region', 'securityCompany', 'labels']
      // for (let k of keyarr) {
      //   this.pageshowConditions[k] = this.conditions[k]
      // }
      this.havelabels = false
      for (let ii in this.conditions) {
        if (!isEmptyObj(this.conditions[ii])) {
          console.log(isEmptyObj(this.conditions.type))
          this.havelabels = true
          this.showMylabels = 2
          break
        }
      }
      this.showPla = false
      let plates = ['SZZB', 'SZZXB', 'SZCYB', 'SHZB', 'N3BTS']
      for (let i of plates) {
        this.pageshowConditions['plate'][i] = ''
        if (this.conditions['plate'][i]) {
          this.showPla = true
          this.pageshowConditions['plate'][i] = this.conditions['plate'][i]
        }
      }
      this.showInd = false
      for (let z in this.pageshowConditions['industry']) {
        this.pageshowConditions['industry'][z] = []
      }
      if (this.pageshowConditions['industry']['S综合']) {
        let pageshowConditions = Object.assign({}, this.pageshowConditions)
        delete pageshowConditions['industry']['S综合']
        this.pageshowConditions = Object.assign({}, pageshowConditions)
      }
      this.pageshowConditions['plate']['挂牌公司'] = []
      if (!isEmptyObj(this.conditions['layer'])) {
        this.showPla = true
        for (let y in this.conditions['layer']) {
          this.pageshowConditions['plate']['挂牌公司'].push(y)
        }
      }
      if (Object.keys(this.conditions['industrysecond']).length > 0) {
        this.showInd = true
        for (let i in this.conditions['industrysecond']) {
          for (let j in this.pageshowConditions['industry']) {
            if (j.indexOf(i.substr(0, 1)) >= 0) {
              let x = i + this.conditions['industrysecond'][i]
              this.pageshowConditions['industry'][j].push(x)
            }
          }
        }
      }
      // console.log(this.pageshowConditions)
      if (this.conditions['industry']['S']) {
        this.showInd = true
        let tmp = {}
        tmp['S综合'] = []
        this.pageshowConditions['industry'] = Object.assign({}, this.pageshowConditions['industry'], tmp)
      }
    },
    // 清空搜索条件
    clearSearch () {
      this.parseUrlQuery({})
      this.addToShow()
    },
    changeKyTtype (ky, ttype, ttname) {
      ky.ttype = ttype
      ky.ttname = ttname
    },
    changeKyOp (ky, optype, opname) {
      ky.optype = optype
      ky.opname = opname
    },
    getTypeByCat (type) {
      // console.log('commonMix.js getYypeByCat')
      let types = []
      for (let t of this.typeAll) {
        if (t.category === type) {
          types.push(t)
        }
      }

      return types
    },
    // 删除筛选条件
    rmvCondition (type, code) {
      // if (this.resultPage === 'G') {
      //   if (!this.companyCode && this.stype !== 4 && !this.validKeywordCondition()) {
      //     alert('请输入关键词或股票代码')
      //     return
      //   }
      // }
      // this.resultPage = 'G'
      // console.log(this.industry)
      // console.log(code[0])
      if (type === 'industrysecond') {
        for (let i of this.industry) {
          if (i.code === code[0]) {
            i.count--
          }
        }
      }
      if (type === 'layer') {
        // console.log(this.plates)
        this.plates[0].count--
      }
      if (type === 'industry') {
        for (let i of this.industry) {
          if (i.code === code) {
            i.count = 0
          }
        }
      }
      if (type === 'N3BGP') {
        // console.log(this.plates)
        this.plates[0].count = 0
      }
      let conditions = Object.assign({}, this.conditions)
      if (type === 'industrysecond') {
        delete conditions['industry'][code.substr(0, 1)]
        delete conditions[type][code]
        this.conditions = Object.assign({}, conditions)
        // alert(code.substr(0,1))
      } else if (type === 'industry') {
        delete conditions['industry'][code]
        for (let item in conditions['industrysecond']) {
          if (item.indexOf(code) >= 0) {
            delete conditions['industrysecond'][item]
          }
        }
        this.conditions = Object.assign({}, conditions)
      }else if (type === 'N3BGP') {
        delete conditions['plate']['N3BGP']
        delete conditions['layer']['创新层']
        delete conditions['layer']['基础层']
        this.conditions = Object.assign({}, conditions)
      } else if (type === 'layer') {
        delete conditions['plate']['N3BGP']
        delete conditions[type][code]
        this.conditions = Object.assign({}, conditions)
      } else {
        delete conditions[type][code]
        this.conditions[type] = Object.assign({}, conditions[type])
      }
      // delete conditions[type][code]
      // this.conditions = Object.assign({}, conditions)
      // console.log(this.conditions)
      if (this.searched) {
        this.go()
      }
      // this.setCnzz('删除条件', '点击删除图标删除条件项')
      this.addToShow()
    },
    // 删除关键词
    rmvKeywordCondition (idx) {
      if (this.keywords_condition.length > 1) {
        this.keywords_condition.splice(idx, 1)
      } else {
        this.keywords_condition.$set(idx, { val: '', ttype: 0, ttname: '全部', optype: 1, opname: '包含全部关键词' })
      }
    },
    setNum (type, d) {
      // console.log('setnum')
      // console.log(this.conditions[type][obj.code])
      // console.log(d)
      // if (!this.conditions[type][obj.code]) {
      //   d.count++
      // } else {
      //   d.count--
      // }
      // console.log(d.code)
      let count = d.count
      count = 0
      if (type === 'industrysecond') {
        let arr = []
        for (let item in this.conditions['industrysecond']) {
          arr.push(item)
        }
        for (let i of arr) {
          if (i.indexOf(d.code) >= 0) {
            count++
          }
        }
        // count = arr.length
        d.count = count
        // console.log(arr)
        // console.log(d.count)
      } else {
        let arr = []
        // console.log(this.conditions['layer'])
        for (let item in this.conditions['layer']) {
          arr.push(item)
        }
        count = arr.length
        d.count = count
      }
    },
    /**
     * 点击添加筛选条件
     * @param type  - 类型名
     * @param obj   - 二级子类项
     * @param d     - 一级子类项
     */
    addCondition (type, obj, d) {
      if (window.location.href.indexOf('result') >= 0) {
        if (!this.companyCode && this.stype !== 4 && !this.validKeywordCondition() && !this.keywords) {
          alert('请输入关键词或股票代码')
          return
        }
      }
      this.showMylabels = 2
      if (type === 'industry') {
        if (!this.conditions[type][obj.code]) {
        // console.log(this.conditions)
        // console.log(obj)
          let tmp = {}
          tmp[obj.code] = obj.name
          this.conditions[type] = Object.assign({}, this.conditions[type], tmp)
          for (let item of this.industry) {
            if (item.code === obj.code && item.child.length > 0) {
              obj.count = item.child.length
              for (let i of item.child) {
                let secind = {}
                secind[i.code] = i.name
                this.conditions['industrysecond'] = Object.assign({}, this.conditions['industrysecond'], secind)
              }
            }
          }
          if (this.searched) {
            this.go()
          }
          console.log(this.conditions)
        } else {
          obj.count = 0
          let conditions = Object.assign({}, this.conditions)
          delete conditions[type][obj.code]
          for (let item of this.industry) {
            if (item.code === obj.code && item.child.length > 0) {
              for (let i of item.child) {
                delete conditions['industrysecond'][i.code]
              }
            }
          }
          this.conditions = Object.assign({}, conditions)
          if (this.searched) {
            this.go()
          }
          console.log(this.conditions)
        }
      }
      else if (type === 'industrysecond') {
        if (!this.conditions[type][obj.code]) {
          // 不存在该子行业
          let tmp = {}
          tmp[obj.code] = obj.name
          // 添加进conditions
          this.conditions[type] = Object.assign({}, this.conditions[type], tmp)
          for (let item of this.industry) {
            if (item.code === obj.code.substr(0, 1)) {
              let count = 0
              for (let i of item.child) {
                if (i.code in this.conditions[type]) {
                  count++
                }
              }
              if (count === item.child.length) {
                let tmp = {}
                tmp[item.code] = item.name
                this.conditions['industry'] = Object.assign({}, this.conditions['industry'], tmp)
              }
              // this.conditions = Object.assign({}, conditions)
            }
          }
          this.setNum(type, d)
          if (this.searched) {
            this.go()
          }
        } else {
          let conditions = Object.assign({}, this.conditions)
          delete conditions[type][obj.code]
          if (conditions['industry'][obj.code.substr(0,1)]) {
            delete conditions['industry'][obj.code.substr(0,1)]
          }
          this.conditions = Object.assign({}, conditions)
          this.setNum(type, d)
          if (this.searched) {
            this.go()
          }
        }
      } else if (obj.name === '挂牌公司') {
        if (!this.conditions['plate'][obj.code]) {
          obj.count = 2
          let tmp = {}
          tmp[obj.code] = obj.name
          this.conditions['plate'] = Object.assign({}, this.conditions['plate'], tmp)
          console.log(this.plates)
          for (let item of this.plates[0].child) {
            let secind = {}
            secind[item.code] = item.name
            this.conditions['layer'] = Object.assign({}, this.conditions['layer'], secind)
          }
          if (this.searched) {
            this.go()
          }
        } else {
          obj.count = 0
          let conditions = Object.assign({}, this.conditions)
          delete conditions['plate'][obj.code]
          for (let item of this.plates[0].child) {
            delete conditions['layer'][item.code]
          }
          this.conditions = Object.assign({}, conditions)
          if (this.searched) {
            this.go()
          }
        }
      } else if (type === 'layer') {
        if (!this.conditions['layer'][obj.code]) {
          let tmp = {}
          tmp[obj.code] = obj.name
          this.conditions['layer'] = Object.assign({}, this.conditions['layer'], tmp)
          let count = 0
          for (let item of this.plates[0].child) {
            if (item.code in this.conditions['layer']) {
              count++
            }
          }
          if (count === 2) {
            let ano = {}
            ano[this.plates[0].code] = this.plates[0].name
            this.conditions['plate'] = Object.assign({}, this.conditions['plate'], ano)
          }
          this.setNum(type, d)
          if (this.searched) {
            this.go()
          }
        } else {
          let conditions = Object.assign({}, this.conditions)
          delete conditions['layer'][obj.code]
          delete conditions['plate']['N3BGP']
          this.conditions = Object.assign({}, conditions)
          this.setNum(type, d)
          if (this.searched) {
            this.go()
          }
        }
      } else {
        if (!this.conditions[type][obj.code]) {
          // console.log(this.conditions)
          // console.log(obj)
          let tmp = {}
          tmp[obj.code] = obj.name
          this.conditions[type] = Object.assign({}, this.conditions[type], tmp)
          console.log(this.conditions)
          console.log('22222')
          console.log(isEmptyObj(this.conditions.type))
          if (this.searched) {
            this.go()
          }
        } else {
          let conditions = Object.assign({}, this.conditions)
          delete conditions[type][obj.code]
          this.conditions[type] = Object.assign({}, conditions[type])
          if (this.searched) {
            this.go()
          }
        }
      }
      console.log(this.conditions)
      this.addToShow()
    },
    /**
     * 添加筛选条件
     * @param type： 类型
     * @param obj： 条件
     */
    addConditionNew: function (type, obj) {
      if (!this.companyCode && this.stype !== 4 && !this.validKeywordCondition() && !this.keywords) {
        alert('请输入关键词或股票代码')
        return
      }
      if (!this.conditions[type][obj.code]) {
        let tmp = {}
        tmp[obj.code] = obj.name
        this.conditions[type] = Object.assign({}, this.conditions[type], tmp)
        if (this.searched) {
          this.go()
        }
      } else {
        let conditions = this.conditions
        delete conditions[type][obj.code]
        this.conditions = Object.assign({}, conditions)
        if (this.searched) {
          this.go()
        }
      }
      this.showMylabels = 2
      this.addToShow()
    },
    validKeywordCondition () {
      for (let kc of this.keywords_condition) {
        let t = kc.val.trim()
        if (t) {
          return true
        }
      }
      return false
    },
  },
}



/** WEBPACK FOOTER **
 ** ./src/common/comSearchMix.js
 **/